// import { useState } from 'react';

// const FakeWordGenerators = () => {
//   const [wordCount, setWordCount] = useState(5);
//   const [wordLength, setWordLength] = useState(5);
//   const [words, setWords] = useState([]);

//   const generateWords = () => {
//     const newWords = [];
//     for (let i = 0; i < wordCount; i++) {
//       let word = '';
//       for (let j = 0; j < wordLength; j++) {
//         word += String.fromCharCode(Math.floor(Math.random() * 26) + 97);
//       }
//       newWords.push(word);
//     }
//     setWords(newWords);
//   };

//   const copyToClipboard = () => {
//     navigator.clipboard.writeText(words.join('\n'));
//   };

//   return (
//     <div className="container mt-5">
//   <h1 className="text-center mb-4">Fake Word Generator  </h1>

//   <div className="row mb-3">
//     <div className="col-md-6">
//       <div className="form-group">
//         <label htmlFor="wordCount">Number of words  </label>
//         <input
//           type="number"
//           className="form-control"
//           id="wordCount"
//           value={wordCount}
//           onChange={(e) => setWordCount(parseInt(e.target.value))}
//         />
//       </div>
//     </div>

//     <div className="col-md-6">
//       <div className="form-group">
//         <label htmlFor="wordLength">word length</label>
//         <input
//           type="number"
//           className="form-control"
//           id="wordLength"
//           value={wordLength}
//           onChange={(e) => setWordLength(parseInt(e.target.value))}
//         />
//       </div>
//     </div>
//   </div>

//   <button className="btn btn-primary mb-3" onClick={generateWords}>
//   Generate words
//   </button>

//   {words.length > 0 && (
//     <div className="mt-4">
//       <h2 className="mb-3">Generated words      </h2>
//       <ul className="list-group mb-3">
//         {words.map((word, index) => (
//           <li key={index} className="list-group-item">{word}</li>
//         ))}
//       </ul>
//       <button className="btn btn-success" onClick={copyToClipboard}>
//       Copy to clipboard
//       </button>
//     </div>
//   )}
// </div>

//   );
// };

// export default FakeWordGenerators;


import { useState } from 'react'; 

const FakeWordGenerators = () => {
  const [language, setLanguage] = useState('en'); // Default language: English
  const [wordCount, setWordCount] = useState(5);
  const [wordLength, setWordLength] = useState(5);
  const [words, setWords] = useState([]);

  const alphabets = {
    en: 'abcdefghijklmnopqrstuvwxyz',
    de: 'abcdefghijklmnopqrstuvwxyzäöüß',
    es: 'abcdefghijklmnopqrstuvwxyzáéíóúñ'
  };

  const generateWords = () => {
    const newWords = [];
    const alphabet = alphabets[language];

    for (let i = 0; i < wordCount; i++) {
      let word = '';
      for (let j = 0; j < wordLength; j++) {
        word += alphabet.charAt(Math.floor(Math.random() * alphabet.length));
      }
      newWords.push(word);
    }
    setWords(newWords);
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(words.join('\n'));
  };

  return (
    <div className="container mt-5">
      <h1 className="text-center mb-4">
        {language === 'en' ? 'Fake Word Generator' : language === 'de' ? 'Falsche Wortgenerator' : 'Generador de Palabras Falsas'}
      </h1>

      <div className="row mb-3">
        <div className="col-md-4">
          <div className="form-group">
            <label htmlFor="language">
              {language === 'en' ? 'Language' : language === 'de' ? 'Sprache' : 'Idioma'}
            </label>
            <select
              className="form-control"
              id="language"
              value={language}
              onChange={(e) => setLanguage(e.target.value)}
            >
              <option value="en">English</option>
              <option value="de">German</option>
              <option value="es">Spanish</option>
            </select>
          </div>
        </div>

        <div className="col-md-4">
          <div className="form-group">
            <label htmlFor="wordCount">
              {language === 'en' ? 'Number of words' : language === 'de' ? 'Anzahl der Wörter' : 'Número de palabras'}
            </label>
            <input
              type="number"
              className="form-control"
              id="wordCount"
              value={wordCount}
              onChange={(e) => setWordCount(parseInt(e.target.value))}
            />
          </div>
        </div>

        <div className="col-md-4">
          <div className="form-group">
            <label htmlFor="wordLength">
              {language === 'en' ? 'Word length' : language === 'de' ? 'Wortlänge' : 'Longitud de palabra'}
            </label>
            <input
              type="number"
              className="form-control"
              id="wordLength"
              value={wordLength}
              onChange={(e) => setWordLength(parseInt(e.target.value))}
            />
          </div>
        </div>
      </div>

      <button className="btn btn-primary mb-3" onClick={generateWords}>
        {language === 'en' ? 'Generate words' : language === 'de' ? 'Wörter generieren' : 'Generar palabras'}
      </button>

      {words.length > 0 && (
        <div className="mt-4">
          <h2 className="mb-3">
            {language === 'en' ? 'Generated words' : language === 'de' ? 'Generierte Wörter' : 'Palabras generadas'}
          </h2>
          <ul className="list-group mb-3">
            {words.map((word, index) => (
              <li key={index} className="list-group-item">{word}</li>
            ))}
          </ul>
          <button className="btn btn-success" onClick={copyToClipboard}>
            {language === 'en' ? 'Copy to clipboard' : language === 'de' ? 'In Zwischenablage kopieren' : 'Copiar al portapapeles'}
          </button>
        </div>
      )}
    </div>
  );
};

export default FakeWordGenerators;
